import { defineMessages } from 'react-intl';

const messages = defineMessages({
  toteNamePlaceholder: {
    description: 'Placeholder for the tote name input field',
    defaultMessage: 'Enter tote name',
    id: 'KtBDd3',
  },
  barcodePlaceholder: {
    description: 'Placeholder for the barcode input field',
    defaultMessage: 'Will be generated if left blank',
    id: 'Ox42UP',
  },
  deleteButtonLabel: {
    description: 'Label for the delete button in the generated totes table',
    defaultMessage: 'Delete',
    id: 'MxSuZl',
  },
  toteNameColumnHeader: {
    description: 'Header for the tote name column',
    defaultMessage: 'Tote name',
    id: 'TP/MYR',
  },
  barcodeColumnHeader: {
    description: 'Header for the barcode column',
    defaultMessage: 'Barcode',
    id: 'zYRgAY',
  },
  warehouseColumnHeader: {
    description: 'Header for the warehouse column',
    defaultMessage: 'Warehouse',
    id: 'rlb08t',
  },
  actionsColumnHeader: {
    description: 'Header for the actions column',
    defaultMessage: 'Action',
    id: 'L5LqWh',
  },
  addToteButton: {
    description: 'Button text for adding a new tote to the table',
    defaultMessage: 'Add tote',
    id: 'sgPfJ8',
  },
  duplicateBarcodeError: {
    description: 'Error message displayed when a duplicate barcode is entered',
    defaultMessage: 'Barcode is already in use. Please enter a different barcode.',
    id: 'f+OnLo',
  },
  duplicateToteNameError: {
    description: 'Error message displayed when a duplicate tote name is entered',
    defaultMessage: 'Name is already in use. Please enter a different name.',
    id: 'sP+Xtz',
  },
});

export default messages;
